<template>
  <el-container class="is-vertical home-page">
    <el-header height="60px" v-if="hasHeader">
      <page-header></page-header>
    </el-header>
    <el-container :key="1" ref="iframeList" v-show="menuActiveRoute.appType === 1" class="iframe-box">
      <div v-loading="true" class="iframe-loading"></div>
    </el-container>
    <el-container :key="2" v-if="menuActiveRoute.appType !== 1" class="main">
      <el-aside class="main-aside" v-if="menuActiveRoute.meta.aside" :width="sideSwitch?'240px':'60px'">
        <side-menu :open="sideSwitch"></side-menu>
        <div class="aside-btn" @click="clicksideSwitch">
          <img class="aside-btn-icon" v-if="sideSwitch" src="@/assets/images/menuIcon/bigArrow.png"/>
          <img class="aside-btn-icon" v-else src="@/assets/images/menuIcon/bigArrowClose.png"/>
          <!-- <span v-if="sideSwitch">收起</span> -->
        </div>
      </el-aside>
      <el-main class="home-main">
        <menu-tabs v-if="childrenRoutes.length>0"></menu-tabs>
         <keep-alive v-if="freshState">
          <router-view :key="key"  v-if="freshState"/>
         </keep-alive>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import PageHeader from './PageHeader'
import SideMenu from './SideMenu/'
import MenuTabs from './MenuTabs'
import {mapGetters} from 'vuex'

export default {
  name: 'mainpage',
  components: {
    PageHeader,
    MenuTabs,
    SideMenu
  },
  data () {
    return {
      sideSwitch: true,
      iframeClassName: 'iframe-content'
    }
  },
  computed: {
    ...mapGetters(['menuActive', 'menuTree', 'menuActiveRoute', 'childrenRoutes', 'tabList', 'freshState']),
    hasHeader () {
      return this.config.hasHeader
      // return true
    },
    // 解决修改和详情时，共用同一个组件的问题
    key () {
      return this.$route.fullPath
    },
    keepPage () {
      const tabList = this.tabList.filter(item => item.meta.keep).map(item => item.name)
      return tabList.join(',')
    }
  },
  updated () {
    // 更新页面，并且判断是否为嵌套页面
    this.iframeWatcher()
  },
  created () {
    // 页面刷新时才会触发created，此时如果在application路由下就返回首页。不然没有iframe可以打开。
    // if (this.$route.name === 'application') {
    this.$router.push({name: 'home'})
    // }
  },
  methods: {
    clicksideSwitch () {
      this.sideSwitch = !this.sideSwitch
      this.$store.commit('setSideSwitch', !this.sideSwitch)
    },
    iframeWatcher () {
      // iframe需要用操作dom插入的形式，不能用v-if或者v-show。不然会导致iframe页面被重新加载
      // console.log(this.menuActiveRoute)
      if (!!this.menuActiveRoute && this.menuActiveRoute['appType'] === 1) {
        const domList = this.$refs.iframeList.$el
        const iframeList = domList.querySelectorAll('.' + this.iframeClassName)
        let iframeDom
        iframeList.forEach(dom => {
          if (dom.name === this.menuActiveRoute.name) {
            iframeDom = dom
          }
        })
        if (iframeList.length > 0 && iframeDom) {
          this._toggleIframe(iframeList)
        } else {
          iframeList && this._toggleIframe(iframeList)
          iframeDom = this._addIframe(this.menuActiveRoute)
          domList.appendChild(iframeDom)
        }
      }
    },
    _toggleIframe (iframeList) {
      iframeList.forEach(dom => {
        dom.style.display = 'none'
        if (dom.name === this.menuActiveRoute.name) {
          dom.style.display = 'block'
        }
      })
    },
    _addIframe (route) {
      var dom = document.createElement('iframe')
      dom.src = route.path
      dom.className = this.iframeClassName
      dom.name = route.name
      return dom
    },
    // 废弃
    handleTabClose (secondTab) {
      const tabIndex = this.secondMenu.findIndex(tab => tab.menuActive === this.menuActive)
      const tab = {...this.secondMenu[tabIndex]}
      const secondIndex = tab.menus.findIndex(menu => menu.name === secondTab)
      if (secondIndex !== -1) {
        if (secondTab === tab.activeName) {
          const secondTabName = tab.menus[secondIndex === 0 ? 1 : secondIndex - 1].name
          tab.activeName = secondTabName
          console.log(tab)
          this.$set(this.secondMenu, tabIndex, tab)
          this.$router.push({name: secondTabName, params: secondTab.params})
        }
        tab.menus.splice(secondIndex, 1)
        // this.noUpdate = true
      }
    }
  }
}
</script>
<style lang="less">
.home-page {
  height: 100%;

  > .el-header {
    padding: 0;
  }

  .main-aside {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    transition: width linear .3s;
    position: relative;
    background-color: transparent;
    overflow: visible;
    z-index: 11;

    .aside-btn {
      position: absolute;
      width: 10px;
      height: 100px;
      cursor: pointer;
      top: 50%;
      margin-top: -50px;
      right: -12px;

      &-icon {
        width: 100%;
        height: 100px;
      }
    }
  }

  .home-main {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .main {
    height: calc(100vh - 62px);
    background-color: #f0f0f0;

    > .el-main {
      padding: 0;
    }
  }

  .iframe-box {
    height: 100%;
    width: 100%;
    position: relative;

    .iframe-content {
      border: none;
      outline: none;
      width: 100%;
      height: 100%;
      z-index: 10;
      position: relative;
    }

    .iframe-loading {
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      z-index: 9;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/area-base/views/layout/Main.vue